import { Container, Grid } from "@material-ui/core";
import * as React from "react";
import { useIntl } from "react-intl";
import { useUpdateMeMutation } from "../../../../api/rtk/MeApi";
import { CandidateViewModel } from "../../../../model/CandidateViewModel";
import CustomDraggableDialog from "../../../common/customDialog/CustomDraggableDialog";
import TranslatedMessage from "../../../translations/TranslatedMessage";
import { useSignUpContext } from "../../CertificationDataWizardContext/CertificationDataWizardContext";
import { ControlButtons } from "../shared/ControlButtons";
import Form from "../shared/Form";
import CandidateAddressFields from "./CandidateAddressFields";
import CandidateFields from "./CandidateFields";
import { getSchema } from "./PersonalDataStepSchema";
import PrivacyPolicyDialog from "./PrivacyPolicyDialog";

const PersonalDataStep: React.FC = () => {
  const intl = useIntl();
  const [ updateMe, { isLoading: isUpdatingMe }] = useUpdateMeMutation();
  const { data, setValues, handleNextStep } = useSignUpContext();
  const [showPrivacyDialog, setShowPrivacyDialog] = React.useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = React.useState(false);
  const [validatedData, setValidatedData] = React.useState<CandidateViewModel | undefined>(undefined);

  const onSubmit = async (data: CandidateViewModel): Promise<void> => {
    setValidatedData(data);
    if (!data.disablePersonalFields) {
      setShowConfirmationDialog(true);
      return;
    }
    setShowPrivacyDialog(true);
  };

  const handleAcceptPrivacyPolicy = async () => {
    if (validatedData && !isUpdatingMe) {
      setValues({ candidate: validatedData });
      var response = await updateMe({
        ...validatedData,
        placeOfOrigin: !validatedData.nationalityIsSwiss ? validatedData.homeCountry : validatedData.placeOfOrigin,
        disablePersonalFields: true,
      }).unwrap();
      if (response.success) {
        handleNextStep();
      }
    }
  };

  const handleCancelPrivacyPolicy = () => {
    setShowPrivacyDialog(false);
    setShowConfirmationDialog(false);
  };

  return (
    <>
      <Form onSubmit={onSubmit} defaultValues={data.candidate} schema={getSchema(intl)}>
        <Container>
          <Grid container={true} direction="column" spacing={8}>
            <CandidateFields />
            <CandidateAddressFields />
          </Grid>
        </Container>
        <ControlButtons />
      </Form>
      <CustomDraggableDialog
        acceptText={<TranslatedMessage id="common.accept" />}
        cancelText={<TranslatedMessage id="common.cancel" />}
        content={<TranslatedMessage id="candidate.disableConfirmationDialog.message" />}
        isOpen={showConfirmationDialog}
        onAccept={() => setShowPrivacyDialog(true)}
        onCancel={() => setShowConfirmationDialog(false)}
        title={<TranslatedMessage id="common.attention" />}
      />
      <PrivacyPolicyDialog
        show={showPrivacyDialog}
        handleAccept={handleAcceptPrivacyPolicy}
        handleCancel={handleCancelPrivacyPolicy}
      />
    </>
  );
};

export default PersonalDataStep;
